module.exports = __webpack_public_path__ + "img/photo-7-2.701884a3.jpg";